import { hideTawkTo, initTawkTo, isTawkToInitialized, parseTawkToConfig, showTawkTo } from '~/utils/tawkTo'
import { markTrackingLoaded } from '~/utils/trackingScope'

export default defineNuxtPlugin(async () => {
  const { fetchSettings, settings, loaded } = useSiteSettings()
  const { trackableShop } = useTrackingScope()
  const router = useRouter()

  if (!loaded.value) {
    await fetchSettings()
  }

  function syncTawkTo() {
    const slug = trackableShop()
    if (!slug) {
      hideTawkTo()
      return
    }

    const config = parseTawkToConfig(settings.value.tawk_to)
    if (!config.enabled) return

    if (!isTawkToInitialized()) markTrackingLoaded(slug)
    if (initTawkTo(config)) {
      showTawkTo()
    }
  }

  watch([loaded, () => router.currentRoute.value.path], syncTawkTo, { immediate: true })
})
